








































import DocumentLink from '@/components/DocumentLink'

export default {
    name: 'ContactBlock'

    props: ['id']

    components: 
        DocumentLink: DocumentLink

    computed:
        isDark: -> @$parent.isDark
        iconClass: ->
            'uk-text-white uk-background-primary': !@isDark
            'uk-text-emphasis uk-background-white': @isDark

    data: ->
        documentId: ''
        fields: @defaultFields()

    methods: 
        defaultFields: ->
            contact_fields: []

        setContent: (document) ->
            @documentId = document.id 
            fields = 
                contact_fields: document.data.contact_fields
            $.extend @fields, fields
        
        getContent: (id) ->
            @$prismic.client.query(@$prismic.Predicates.at 'document.id', id).then (response) =>
                if response.results then @setContent response.results[0]
        
    created: ->
        @getContent @id
}
